//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AddressFields from './partials/Address.vue';
import OrdersTable from './partials/OrdersTable.vue';
import ChangePassword from './partials/ChangePassword.vue';

export default {
  name: 'Account',
  components: {
    AddressFields,
    OrdersTable,
    ChangePassword,
  },
  props: {
    billing: {
      type: Object,
      default: () => {},
    },
    email: {
      type: String,
      default: '',
    },
    shipping: {
      type: Object,
      default: () => {},
    },
    orders: {
      type: Array,
      default: () => [],
    },
    detailId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      currentTab: 'orders',
      tabs: [
        { name: 'Objednávky', id: 'orders' },
        { name: 'Adresa', id: 'addresses' },
        { name: 'Heslo', id: 'password' },
      ],
      localBilling: {},
      localShipping: {},
    };
  },
  methods: {
    logout() {
      const data = {
        action: 'vue_logout',
      };
      $.ajax({
        type: 'POST',
        url: wc_add_to_cart_params.ajax_url,
        data,
        success: () => {
          window.location = '/';
        },
      });
    },
  },
  mounted() {
    this.localBilling = { ...this.billing };
    this.localShipping = { ...this.shipping };
    if (this.detailId) {
      this.currentTab = 'orders';
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/vue/auth/Account.vue